module.exports = __webpack_public_path__ + "static/img/two.db75fcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/12/two.png
// module id = InMK
// module chunks = 1